import * as types from './mutation-types';

export default {
  [types.UPDATE_DATE](state, payload) {
    state.date = payload;
  },
  [types.UPDATE_TIMESTAMP](state, payload) {
    state.timestamp = payload;
  },
  [types.UPDATE_LC](state, payload) {
    state.lc = payload;
  },
  [types.UPDATE_INIT_DATA](state, payload) {
    state.initData = payload;
  },
  [types.UPDATE_ORDER_DETAIL](state, payload) {
    state.orderDetail = payload;
  },
};



// WEBPACK FOOTER //
// ./src/pages/homepage/store/mutations.js